import { Route, Routes } from 'react-router-dom';

import TeacherPage from './teacher-page';
import TeachersPage from './teachers-page';

export default function Teachers() {
    return (
        <Routes>
            <Route
                path="/"
                element={<TeachersPage />}
            />

            <Route
                path="/:id"
                element={<TeacherPage />}
            />
        </Routes>
    );
}